function formatClassicRussianPhone(phoneNumber) {
  if (phoneNumber == null || phoneNumber === '') return phoneNumber;
  let phone = typeof phoneNumber === 'number' ? String(phoneNumber) : phoneNumber;
  if (typeof phone !== 'string') return phoneNumber;
  if (phone[0] !== '+') phone = `+${phone}`;

  return `${phone.slice(0, 2)} ${phone.slice(2, 5)} ${phone.slice(5, 8)} ${phone.slice(8, 10)} ${phone.slice(10, 12)}`;
}

/**
 * @param {string} phone — цифровая строка (например 71234567890)
 * @param {string} [phonePrefixed] — формат с подчёркиваниями (например 7_12345_67890)
 */
export function formatPhoneForDisplay(phone, phonePrefixed) {
  if (phonePrefixed != null && String(phonePrefixed).includes('_')) {
    const parts = String(phonePrefixed).split('_');
    if (parts[0] === '7' && parts.length >= 2) {
      const prefixSegment = parts[1] || '';
      const prefixDigits = prefixSegment.replace(/\D/g, '');
      if (prefixDigits.length !== 3) {
        return `+${parts[0]} ${parts.slice(1).join(' ')}`;
      }
    }
  }

  return formatClassicRussianPhone(phone);
}

export default formatPhoneForDisplay;
